var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.base.wrapper, _vm.width !== 'none' && _vm.base[_vm.width]]},[_vm._t("default",[_vm._v("Add some stuff here!")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }